const Map = () => (
  <iframe
    className="border-0 mb-20"
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11971.832123191416!2d2.1546216!3d41.3967178!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1a5612604d25476c!2sFederaci%C3%B3%20Catalana%20de%20P%C3%A0del!5e0!3m2!1sen!2sgr!4v1676881996493!5m2!1sen!2sgr"
    width="100%"
    height="600"
    allowfullscreen=""
    loading="lazy"
  ></iframe>
)

export default Map
